"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
var utils_1 = require("../utils");
var storeShape = prop_types_1.default.shape({
    subscribe: prop_types_1.default.func.isRequired,
    dispatch: prop_types_1.default.func.isRequired,
    getState: prop_types_1.default.func.isRequired,
});
function extendHOC(WrappedComponent, WrapperComponent, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withStore, withStore = _c === void 0 ? false : _c;
    var Hoc = /** @class */ (function (_super) {
        __extends(Hoc, _super);
        // constructor(props: WrapperProps, context: App.Context) {
        function Hoc(props, context) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedRef = function (ref) {
                _this.wrappedRef = ref;
            };
            _this.getWrappedRef = function (_a) {
                var _b = _a === void 0 ? {} : _a, skipConnect = _b.skipConnect;
                // Component is wrapped with react-redux connect
                if (skipConnect &&
                    _this.wrappedRef &&
                    typeof _this.wrappedRef.getWrappedInstance === 'function') {
                    return _this.wrappedRef.getWrappedInstance();
                }
                return _this.wrappedRef;
            };
            _this.getRefKey = function (type) {
                // it is necessary to get propTypes from another component
                var withReactRouter = type &&
                    type.propTypes && // eslint-disable-line
                    type.propTypes.hasOwnProperty('wrappedComponentRef'); // eslint-disable-line
                return withReactRouter ? 'wrappedComponentRef' : 'ref';
            };
            if (withStore) {
                _this.store = context.store;
            }
            return _this;
        }
        Hoc.prototype.render = function () {
            var _a;
            var reactElement = _super.prototype.render.call(this);
            if (reactElement == null)
                return null;
            var type = reactElement.type;
            // Stateless function components cannot be given refs;
            // should handle withRouter with custom ref key
            // if (!isClassComponent(WrappedComponent)) {
            //     console.warn('SFC detected:', WrappedComponent.displayName);
            // }
            return react_1.default.cloneElement(reactElement, (_a = {},
                _a[this.getRefKey(type)] = this.setWrappedRef,
                _a));
        };
        // static contextTypes: React.ValidationMap<App.Context> = {
        Hoc.contextTypes = {
            store: storeShape,
        };
        Hoc.WrappedComponent = WrappedComponent;
        Hoc.displayName = "with" + utils_1.getDisplayName(WrapperComponent) + "(" + utils_1.getDisplayName(WrappedComponent) + ")";
        return Hoc;
    }(WrapperComponent));
    hoist_non_react_statics_1.default(Hoc, WrapperComponent);
    return Hoc;
}
exports.default = extendHOC;
// function isClassComponent(Component): boolean {
//     return Boolean(
//         Component &&
//             Component.prototype &&
//             typeof Component.prototype.render === 'function'
//     );
// }
//# sourceMappingURL=extendHOC.js.map